import React, { useCallback, useEffect } from 'react';
import './Flow.css'

import {
  ReactFlow,
  addEdge,
  useNodesState,
  useEdgesState,
  MarkerType,
  useReactFlow,
} from '@xyflow/react';

import '@xyflow/react/dist/style.css';

import FloatingEdge from './FloatingEdge';



const edgeTypes = {
  floating: FloatingEdge,
};

const defaultEdgeOptions = {
  type: 'floating',
  markerEnd: {
    type: MarkerType.ArrowClosed,
    color: 'var(--background-color)',
  },
};

const Flow = ({nodeTypes, initialNodes, initialEdges, update_positions, onConnect, focus, focusedId, selectConn, onDelete}) => {
  
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);

  const createEdge = (connection) => {
    return {
        "id": connection.id,
        "markerEnd": {
            "type": "arrowclosed",
            "color": "var(--text-color)"
        },
        "style": {
            "stroke": "var(--text-color)",
            "strokeWidth": 4
        },
        "type": "floating",
        "source": `${connection.source_service_id}`,
        "target": `${connection.destination_service_id}`,
        "label": `connection from ${connection.source_service_id} to ${connection.destination_service_id}`,
        "data": {
            ...connection,
            "selectConn": selectConn,
            "onDelete": (connection_id)=>{onDelete(connection_id); setEdges((eds) => eds.filter((e) => e.id !== connection_id));}
            },
        }
    }
 const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges.map(edge => (createEdge(edge))));
  

    const { fitView } = useReactFlow();
    const onConnecting = useCallback(
      async (params) =>
        {
            
          const connection = await onConnect(params.source, params.target)
          setEdges((eds) =>
            addEdge(
              createEdge(connection),
              eds
            )
          )},
      []
    );
  
  
    const onNodeDragStop = useCallback(
      (_, node) => {update_positions(Number(node.id), node.position.x, node.position.y); },
      []
    );
  

    useEffect(() => {
    const timer = setTimeout(() => {
      fitView();
    }, 1); // milliseconds

    return () => clearTimeout(timer);
  }, []);

  useEffect(()=>{
    fitView({
      nodes: [{ id: `${focusedId}` }],
      padding: 0.5,
      duration: 800,
    })
  }, [focusedId])

  useEffect(()=>{
    setNodes(initialNodes)
  }, [initialNodes])


  return (
    <ReactFlow
      nodeTypes={nodeTypes}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
      nodesConnectable={true}
      minZoom={0.01}
      maxZoom={2} 
      onNodeDragStop={onNodeDragStop}
      edgeTypes={edgeTypes}
      nodes={nodes}
      edges={edges}
      onConnect={onConnecting}
      defaultEdgeOptions={defaultEdgeOptions}
    >
        <button className='recenter-button' onClick={()=>{fitView({duration: 800});}}>recenter</button>
    </ReactFlow>
  );
};

export default Flow;
